// leadershipData.js
export const executiveData = [
  {
    id: 1,
    name: "Miguel Galuccio",
    role: "Founder – Chairman of the Board and Chief Executive Officer",
    bio: [
      "Miguel Galuccio serves as Chairman of the Board and Chief Executive Officer of the company. He is currently an independent member of the board of directors of SLB, the world’s largest oilfield services company.",
      "From May 2012 to April 2016, Mr. Galuccio was Chairman of the Board and Chief Executive Officer of YPF, Argentina’s leading oil company.",
      "Mr. Galuccio is a petroleum engineer who graduated from the Buenos Aires Institute of Technology (ITBA) in Argentina."
    ]
  },
  {
    id: 2,
    name: "Pablo Vera Pinto",
    role: "Chief Financial Officer",
    bio: [
      "Pablo Vera Pinto is the Chief Financial Officer of the company.",
      "He has extensive experience in corporate finance and capital markets."
    ]
  },

  {
    id: 3,
    name: "Miguel Galuccio",
    role: "Founder – Chairman of the Board and Chief Executive Officer",
    bio: [
      "Miguel Galuccio serves as Chairman of the Board and Chief Executive Officer of the company. He is currently an independent member of the board of directors of SLB, the world’s largest oilfield services company.",
      "From May 2012 to April 2016, Mr. Galuccio was Chairman of the Board and Chief Executive Officer of YPF, Argentina’s leading oil company.",
      "Mr. Galuccio is a petroleum engineer who graduated from the Buenos Aires Institute of Technology (ITBA) in Argentina."
    ]
  },
  {
    id: 4,
    name: "Pablo Vera Pinto",
    role: "Chief Financial Officer",
    bio: [
      "Pablo Vera Pinto is the Chief Financial Officer of the company.",
      "He has extensive experience in corporate finance and capital markets."
    ]
  },
  {
    id: 5,
    name: "Miguel Galuccio",
    role: "Founder – Chairman of the Board and Chief Executive Officer",
    bio: [
      "Miguel Galuccio serves as Chairman of the Board and Chief Executive Officer of the company. He is currently an independent member of the board of directors of SLB, the world’s largest oilfield services company.",
      "From May 2012 to April 2016, Mr. Galuccio was Chairman of the Board and Chief Executive Officer of YPF, Argentina’s leading oil company.",
      "Mr. Galuccio is a petroleum engineer who graduated from the Buenos Aires Institute of Technology (ITBA) in Argentina."
    ]
  },
  {
    id: 6,
    name: "Pablo Vera Pinto",
    role: "Chief Financial Officer",
    bio: [
      "Pablo Vera Pinto is the Chief Financial Officer of the company.",
      "He has extensive experience in corporate finance and capital markets."
    ]
  }
];
